/* eslint-disable import/extensions */
// @ts-expect-error, the whole import behaviour for this library is a bit weird as it has now native typescript support
import { Sortable, AutoScroll } from 'sortablejs/modular/sortable.core.esm.js';

Sortable.mount(new AutoScroll());
